import React from "react";
import { BundleInterface } from "src/store/gh_market/bundlesSlice";
import { RightSidebar } from "src/pages/_partials/Layout/RightSidebar";
import RowInfo from "src/componets/RowInfo";

const _SidebarShow = ({ bundle }: { bundle: BundleInterface | undefined }) => {
  if (!bundle) return null;

  return (
    <RightSidebar>
      <h6 className='v-content-label'>BUNDLE INFO</h6>
      <hr className="v-divider" />

      <div className='v-mb-20'>
        <h6 className='v-content-label o-sm'>Base Information</h6>
        <RowInfo left='#ID' right={bundle.id} />
        <RowInfo left='Bundle Name' right={bundle.name} />
        <RowInfo left='Platform' right={bundle.platform === 'ios' ? 'iOS' : 'Android'} />
      </div>

      {bundle.platform === 'ios' && (
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>iOS Configuration</h6>
          <RowInfo left='Shared Secret' right={bundle.shared_secret || '—'} />
        </div>
      )}

      {bundle.platform === 'android' && (
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Android Configuration</h6>
          <RowInfo left='ISS' right={bundle.iss || '—'} />
          <RowInfo left='RSA Private Key' right={bundle.rsa_private_key ? 'Set' : '—'} />
        </div>
      )}
    </RightSidebar>
  );
}

export default _SidebarShow;
